import Layout from "../pages/shared/layout";
import ApplicationRoute from "./application";
import DisDeclineRoute from "./dis-decline-route";
import DisSkipSignRoute from "./dis-skipsign-route";
import DisSuccessRoute from "./dis-success-route";
import LoginRoute from "./login-route";
import PasswordReset from "./password-reset";
import React from "react";

export type RouteConfig = {
  path: string;
  component: React.FC<{ routes: RouteConfig[] }>;
  exact?: boolean;
  routes?: RouteConfig[];
};

const index: RouteConfig[] = [
  {
    path: "/*",
    component: Layout,
    routes: [
      {
        path: "/",
        exact: true,
        component: ApplicationRoute,
      },
      {
        path: "/login",
        exact: true,
        component: LoginRoute,
      },
      {
        path: "/password-reset",
        exact: true,
        component: PasswordReset,
      },
      {
        path: "/success",
        exact: true,
        component: DisSuccessRoute,
      },
      {
        path: "/decline",
        exact: true,
        component: DisDeclineRoute,
      },
      {
        path: "/skipSign",
        exact: true,
        component: DisSkipSignRoute,
      },
    ],
  },
];

export default index;
